import { RouteObject } from 'react-router-dom';
import AuthGuard from 'utils/route-guard/AuthGuard';
import OnboardingCompany from 'views/pages/onboarding/OnboardingCompany';
import RouteErrorBoundary from 'views/pages/maintenance/RouteErrorBoundary';

const OnboardingRoutes: RouteObject = {
  path: '/company-onboarding',
  element: (
    <AuthGuard>
      <OnboardingCompany />
    </AuthGuard>
  ),
  errorElement: <RouteErrorBoundary />,
};

export default OnboardingRoutes;
